
import { computed, defineComponent, PropType } from 'vue'
import { EmailDeliveryPolicy } from '@/modules/billing-templates'
import BillingTemplatesFormFieldBillingEmail from '@/components/billing-templates/form-fields/billing-email.vue'

export default defineComponent({
    name: 'billing-templates-email-delivery-policy-form-part',
    components: {
        BillingTemplatesFormFieldBillingEmail
    },
    props: {
        modelValue: {
            type: Object as PropType<EmailDeliveryPolicy>,
            required: true
        }
    },
    emits: ['update:modelValue'],
    setup (props, { emit }) {
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        return {
            localModel
        }
    }
})
